import { mapGetters } from 'vuex';
import { CONVERSATION_EVENTS } from 'dashboard/helper/AnalyticsHelper/events';

export default {
  computed: {
    ...mapGetters({
      chatList: 'getAllConversations',
    }),
    hasAccounts() {
      const { accounts = [] } = this.currentUser || {};
      return accounts.length > 0;
    },
  },
  methods: {
    async execAassignPriority(priority, conversationId = null) {
      this.$store.dispatch('setCurrentChatPriority', {
        priority,
        conversationId,
      });
      this.$store
        .dispatch('assignPriority', { conversationId, priority })
        .then(() => {
          this.$track(CONVERSATION_EVENTS.CHANGE_PRIORITY, {
            newValue: priority,
            from: 'Context menu',
          });
          this.showAlert(
            this.$t('CONVERSATION.PRIORITY.CHANGE_PRIORITY.SUCCESSFUL', {
              priority:
                priority || this.$t('CONVERSATION.PRIORITY.OPTIONS.NONE'),
              conversationId,
            }),
            'success'
          );
        });
    },
    async execUpdateConversation(status, snoozedUntil, conversationId = null) {
      const conversation = this.$store.getters.getConversationById(
        conversationId
      );
      if (conversation) {
        await this.checkToggleStatus(status, snoozedUntil, conversation);
      }
    },
    async execAssignTeam(team, conversationId = null) {
      try {
        await this.$store.dispatch('assignTeam', {
          conversationId,
          teamId: team.id,
        });
        this.showAlert(
          this.$t(
            'CONVERSATION.CARD_CONTEXT_MENU.API.TEAM_ASSIGNMENT.SUCCESFUL',
            {
              team: team.name,
              conversationId,
            }
          ),
          'success'
        );
      } catch (error) {
        this.showAlert(
          this.$t('CONVERSATION.CARD_CONTEXT_MENU.API.TEAM_ASSIGNMENT.FAILED'),
          'error'
        );
      }
    },
    async execAssignAgent(agent, conversationId = null) {
      try {
        await this.$store.dispatch('bulkActions/process', {
          type: 'Conversation',
          ids: conversationId,
          fields: {
            assignee_id: agent.id,
          },
        });
        this.showAlert(
          this.$t(
            'CONVERSATION.CARD_CONTEXT_MENU.API.AGENT_ASSIGNMENT.SUCCESFUL',
            {
              agentName: agent.name,
              conversationId,
            }
          ),
          'success'
        );
      } catch (err) {
        this.showAlert(this.$t('BULK_ACTION.ASSIGN_FAILED'), 'error');
      }
    },
    async execAssignLabel(labels, conversationId = null) {
      try {
        await this.$store.dispatch('bulkActions/process', {
          type: 'Conversation',
          ids: conversationId,
          labels: {
            add: labels,
          },
        });
        this.showAlert(
          this.$t(
            'CONVERSATION.CARD_CONTEXT_MENU.API.LABEL_ASSIGNMENT.SUCCESFUL',
            {
              labelName: labels[0],
              conversationId,
            }
          ),
          'success'
        );
      } catch (err) {
        this.showAlert(this.$t('BULK_ACTION.LABELS.ASSIGN_FAILED'), 'error');
      }
    },
    async execMarkAsUnread(conversationId) {
      try {
        await this.$store.dispatch('markMessagesUnread', {
          id: conversationId,
        });
      } catch (error) {
        // Ignore error
      }
    },
  },
};
